import QuestionUpdateWarning from "pages/QuestionPage/QuestionUpdateWarning/QuestionUpdateWarning";

export default QuestionUpdateWarning;
